import Component from 'component';
import 'jquery-validation';
class FormValidate extends Component {
  constructor(el) {
    super(el);
    this.addCustomNameValidation();
    this.addCustomPhoneNumberValidation();
    this.addCustomEmailAddressValidation();
    this.addCustomZipCodeValidation();
    this.initFormValidate();
  }

  setupDefaults() {
    this.dom = {
      $formLevelErrorContainer: this.$el.prev('.form__global-error'),
      $formDropdowns: this.$el.find('select')
    };
  }

  addListeners() {
    //this.dom.$formDropdowns.on('change', ::this.onDropdownChange);
  }

  onDropdownChange(e) {
    $(e.target).valid();
  }

  addCustomNameValidation() {
    jQuery.validator.addMethod('name', function(value, element) {
      if (this.optional(element) || /\w/ig.test(value)){
        return true;
      }
      jQuery.validator.messages.name = 'Invalid name';
      return false;
    });

    jQuery.validator.addClassRules('callout-field__field-text', {
      name: 'Invalid name'
    });
  }

  addCustomPhoneNumberValidation() {
    jQuery.validator.addMethod('phone', function(value, element) {
      return this.optional(element) || /^(\+?(1\s)?)[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(value);
    });

    jQuery.validator.addClassRules('callout-field__phone-number', {
      phone: true
    });
  }

  addCustomEmailAddressValidation() {
    jQuery.validator.addMethod('email', function(value, element) {
      if (this.optional(element) || /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(value)){
        return true;
      }
      jQuery.validator.messages.email = 'Invalid email address';
      return false;
    });

    jQuery.validator.addClassRules('callout-field__field-email-address', {
      email: 'Invalid email address'
    });
  }

  addCustomZipCodeValidation() {
    const message = 'Invalid zip/postal code';
    jQuery.validator.addMethod('zip', function(value, element) {
      /*if (this.optional(element) || /(^\d{5}$)|(^\d{5}[ -]?\d{4}$)/.test(value) || /(^[A-Za-z]\d[A-Za-z][ -]?(?:\d[A-Za-z]\d)?$)/.test(value)){*/
      if (this.optional(element) || /(^\d{5}$)|(^\d{5}[ -]?\d{4}$)/.test(value) || /(^[A-Za-z]\d[A-Za-z][ -]?(?:\d[A-Za-z]\d)?$)/.test(value)){
        return true;
      }
      jQuery.validator.messages.zip = message;
      return false;
    });

    jQuery.validator.addClassRules('callout-field__field-zip-code', {
      zip: message
    });
  }

  initFormValidate() {
    this.$el.on('blur', 'input[type=text],input[type=tel],input[type=email]', function(){
      $(this).val($(this).val().trim());
    });
    this.$el.validate();
  }
}

export default FormValidate;



// WEBPACK FOOTER //
// ./src/pg/js/components/FormValidate.js